import { fetchApi } from "../utils/fetchApi";

export function fetchTargetdemand({ filter = {}, options = {} }) {
  return fetchApi({ url: `targetdemand`, filter: {}, options });
}

